import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxpayers,
    taxCode,
    taxAgentName,
    taxAgentCode,

    company,
    unitCompany,
    from,
    firstTime,
    mst,
    strangeFrom,
    strangeTo,
    time,

    chiefAccountant,
    certificateNumber,
    unitHeads,
    dateFounded,
  },
} = checkout;

const validation = Yup.object().shape({
  [taxpayers.name]: Yup.string().required(taxpayers.errorMsg),
  [taxCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxCode.invalidMsg)
    .required(taxCode.errorMsg),

  [taxAgentName.name]: Yup.string().optional(),
  [taxAgentCode.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentCode.invalidMsg)
    .optional(),

  [company.name]: Yup.string().required(company.errorMsg),
  [unitCompany.name]: Yup.string().required(unitCompany.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [from.name]: Yup.string().required(from.errorMsg),
  [mst.name]: Yup.string().required(mst.errorMsg),
  [strangeFrom.name]: Yup.string().required(strangeFrom.errorMsg),
  [strangeTo.name]: Yup.string().required(strangeTo.errorMsg),
  [time.name]: Yup.string().required(time.errorMsg),

  [chiefAccountant.name]: Yup.string().required(chiefAccountant.errorMsg),
  [certificateNumber.name]: Yup.string().required(certificateNumber.errorMsg),
  [unitHeads.name]: Yup.string().required(unitHeads.errorMsg),
  [dateFounded.name]: Yup.number().required(dateFounded.errorMsg),
});

export default validation;
